import { Box, BoxProps, Stack, Typography, useTheme } from '@mui/material';

import { PortalTheme } from '@frontend-libs/portal';

import { OpacityAnimation } from './opacity-animation.component';

export interface TitleSectionProps extends BoxProps {
  fullWidth?: boolean;
  title: string;
  rightAction?: React.ReactNode;
}

export const TitleSection = ({
  fullWidth,
  sx,
  children,
  rightAction,
  ...props
}: TitleSectionProps) => {
  const theme = useTheme<PortalTheme>();
  return (
    <Box
      component="section"
      {...props}
      sx={{
        width: '100%',
        alignSelf: 'center',
        px: fullWidth ? 0 : 2,
        ...sx,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        alignSelf="center"
        width="100%"
        maxWidth={theme.contentMaxWidth}
        px={2}
        pb={1.5}
        pt={3}
      >
        <Typography variant="h4">{props.title}</Typography>
        {rightAction}
      </Stack>

      <OpacityAnimation>{children}</OpacityAnimation>
    </Box>
  );
};
